import React from "react";
import logo from "../assets/jkccLogo.png";
import "../styles/ScreenLoader.css";

const ScreenLoader: React.FC = () => {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-yellow-50 via-white to-gray-50 flex flex-col items-center justify-center z-50">
        {/* Logo with pulse animation */}
        <div className="relative">
          <div className="absolute inset-0 bg-yellow-400/20 rounded-full blur-2xl animate-pulse"></div>
          <img 
            src={logo} 
            alt="JKCC Logo" 
            className="bouncing-logo relative z-10" 
            width={120}
          />
        </div>
        
        {/* Loading text */}
        <div className="mt-8 flex flex-col items-center gap-4">
          <p className="text-xl font-semibold text-zinc-800">Loading...</p>
          
          {/* Animated dots */}
          <div className="flex gap-2">
            <div className="w-3 h-3 bg-yellow-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-3 h-3 bg-yellow-600 rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    );
};

export default ScreenLoader;